export const FREE_TRIAL_FEATURE_FLAG_KEY = '7_day_ft_2024';
